require('../../modules/es.symbol');
var path = require('../../internals/path');

module.exports = path.Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/get-own-property-symbols.js
// module id = 634
// module chunks = 0 1